/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PaymentStatusV1Code {
    PREPARING = 'Preparing',
    READY_FOR_AUTHORIZE = 'ReadyForAuthorize',
    AUTHORIZING = 'Authorizing',
    SUCCEEDED = 'Succeeded',
    FAILED = 'Failed',
    CANCELLED = 'Cancelled',
    PENDING = 'Pending',
}